import { Component, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { Util } from 'src/shared/util/util';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

@Component({
    selector: 'integrate-upsell-provider',
    templateUrl: './integrate-upsell-provider.component.html',
    styleUrls: ['./integrate-upsell-provider.component.scss'],
    standalone: false
})

export class IntegrateUpsellProviderComponent {

  whatToOfferItems = [
    {
      name: 'Early check in',
      description: 'Enable automated handling of early check-in requests.',
      isSelected: false
    },
    {
      name: 'Late check out',
      description: 'Enable automated handling of late check-out requests.',
      isSelected: false
    },
    {
      name: 'Mid-stay clean',
      description: 'Enable automated handling of mid-stay clean requests.',
      isSelected: false
    }
  ]

  howToRequestItems = [
    {
      name: 'A digital guidebook',
      isSelected: false
    },
    {
      name: 'A PMS',
      isSelected: false
    },
    {
      name: 'Directly on platform (Airbnb, etc)',
      isSelected: false
    }
  ]

  boundSave = this.save.bind(this);

  private readonly conciergeApi = inject(ConciergeApiService);
  private readonly util = inject(Util);
  private readonly onboardingProvider = inject(OnboardingProvider);

  constructor() {}

  selectWhatToOffer(item) {
    item.isSelected = !item.isSelected;
  }

  selectHowToRequestUpsells(item) {
    item.isSelected = !item.isSelected;
  }

  async save() {
    try {
      await Promise.all([
        lastValueFrom(this.conciergeApi.createConciergeItem({
          data: {
            subject: 'Upsell Settings',
            body: `What do you want to offer answers: ${  this.whatToOfferItems.filter(item => item.isSelected).map(item => item.name).join(', ')  } / How do you want guests to request upsells answers: ${  this.howToRequestItems.filter(item => item.isSelected).map(item => item.name).join(', ')}`,
            emails: [],
            attachments: []
          },
          type: 'support.concierge_task',
        })),
        this.onboardingProvider.markGoalAsCompleted('upsell')
      ]);
      this.onboardingProvider.setShowOnboardingOnPage(false);
      this.onboardingProvider.setShowOnboardingInDashboard(true);
      this.onboardingProvider.setShowOnboardingInHeader(true);
      this.util.showSuccess('Upsell settings saved');
    } catch (err) {
      this.util.showError(err?.error?.message ? err.error.message : err.message);
    }
  }
  
} 